<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/servicesbg5.jpg')})`}"></div>
    </div>
    <div class="inner-pannel">
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <div style="height:55px;"></div>
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
              <div :class="$i18n.locale=='zh'?'text zh-font':'text en-font'">{{$t('valueAdded.content')}}</div>
              <div style="height:20px;"></div>
              <span class="jiantou"  @click="show">{{ $t('index.about.more') }}<i :class="showHidden?'el-icon-arrow-up':'el-icon-arrow-down'"></i></span>
              <div style="height:40px;"></div>
              <div class="main-1 ani animate__animated animate__fadeInDown" v-if="showHidden">
                  <div class="main-item-1">
                        <div :class="$i18n.locale=='zh'?'title-1':'title-2'">{{$t('valueAdded.list[0].title')}}</div>
                        <img src="../../assets/images/jiantou.png" style="width:16px;margin: 19px auto 10px auto;">
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd1.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[0].content1')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd2.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[0].content2')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd3.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[0].content3')}}</div>
                        </div>
                  </div>
                  <div class="main-item-1">
                        <div :class="$i18n.locale=='zh'?'title-1':'title-2'">{{$t('valueAdded.list[1].title')}}</div>
                        <img src="../../assets/images/jiantou.png" style="width:16px;margin: 19px auto 10px auto;">
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd4.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[1].content1')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd5.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[1].content2')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd6.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[1].content3')}}</div>
                        </div>
                  </div>
                  <div class="main-item-1">
                        <div :class="$i18n.locale=='zh'?'title-1':'title-2'">{{$t('valueAdded.list[2].title')}}</div>
                        <img src="../../assets/images/jiantou.png" style="width:16px;margin: 19px auto 10px auto;">
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd7.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[2].content1')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd8.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[2].content2')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd9.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[2].content3')}}</div>
                        </div>
                  </div>
                  <div class="main-item-1">
                        <div :class="$i18n.locale=='zh'?'title-1':'title-2'">{{$t('valueAdded.list[3].title')}}</div>
                        <img src="../../assets/images/jiantou.png" style="width:16px;margin: 19px auto 10px auto;">
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd10.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[3].content1')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd11.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[3].content2')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd12.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[3].content3')}}</div>
                        </div>
                  </div>
                  <div class="main-item-1">
                        <div :class="$i18n.locale=='zh'?'title-1':'title-2'">{{$t('valueAdded.list[4].title')}}</div>
                        <img src="../../assets/images/jiantou.png" style="width:16px;margin: 19px auto 10px auto;">
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd13.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[4].content1')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd14.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[4].content2')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd15.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[4].content3')}}</div>
                        </div>
                  </div>
                  <div class="main-item-1">
                        <div :class="$i18n.locale=='zh'?'title-1':'title-2'">{{$t('valueAdded.list[5].title')}}</div>
                        <img src="../../assets/images/jiantou.png" style="width:16px;margin: 19px auto 10px auto;">
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd16.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[5].content1')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd17.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[5].content2')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd18.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[5].content3')}}</div>
                        </div>
                  </div>
                  <div class="main-item-1">
                        <div :class="$i18n.locale=='zh'?'title-1':'title-2'">{{$t('valueAdded.list[6].title')}}</div>
                        <img src="../../assets/images/jiantou.png" style="width:16px;margin: 19px auto 10px auto;">
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd19.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[6].content1')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd20.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[6].content2')}}</div>
                        </div>
                        <div :class="$i18n.local=='zh'?'item-1':'item-2'">
                            <img src="../../assets/images/valueadd21.png" style="width:55px;margin:0 auto">
                            <div class="content">{{$t('valueAdded.list[6].content3')}}</div>
                        </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default({
  data() {
    return{
      showHidden:false
    }
  },
  methods:{
    show() {
      this.showHidden = !this.showHidden
    }
  }
})
</script>
<style scoped>
    .topPoint::after {
        width: 25px;
        height: 25px;
        content: "";
        position: absolute;
        background: #ed6d00;
        border-radius: 50%;
        z-index: 1;
        top: -12.5px;
        right: -12.5px;
    }
    /deep/ .el-collapse-item__wrap{
      padding-left: 0;
    }
    .jiantou{
        color: #ffffff!important;
        font-family: 'Lato','Microsoft JhengHei';
        /* position: absolute; */
        /* right: 0; */
        cursor:pointer;
    }
    .inner-pannel{
      min-height: 100%;
      padding-bottom: 54px;
      position: static;
      /* position: relative; */
      /* position: absolute; */
      width: 100%;
      font-family: 'Lato''Microsoft JhengHei';
    }
    .main-1{
        width: 90%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .main-item-1{
        width: 125px;
        /* width: calc(100% / 7); */
        text-align: center;
    }
    .title-1{
        /* font-size: 24px; */
        color: #ED6D00;
    }
    .title-2{
        min-height: 34px;
        font-size: 16px;
        color: #ED6D00;
    }
    .content{
        font-size: 20px;
    }
    .item-1{
        margin-bottom: 26px;
        min-height: 100px;
    }
    .item-2{
        margin-bottom: 26px;
        min-height: 120px;
    }
    .column{
        height: 80%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .el-icon-arrow-down::before {
        color: #ffffff!important;
    }
    .el-icon-arrow-up::before{
        color: #ffffff!important;
    }
    /* >=1300 <=1600*/
    @media only screen and (min-width: 1300px) and (max-width: 1600px){
        .title{
            font-size: 22px;
        }
        .main-1{
            width: 95%;
        }
        .main-item-1{
            width: 100px;
        }
    }
    @media screen and (max-width:1400px) {
        .title-2{
            font-size: 14px;
        }
    }
    @media screen and (max-width:768px) {
        .main-1{
            width: 100%;
        }
        /deep/ .el-collapse {
            width: 100%!important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/valueAdded/valueAdded.vue